import React from "react";
import notify from "devextreme/ui/notify";
import Form, {
  SimpleItem,
  GroupItem,
  Label,
  EmptyItem,
  ButtonItem,
} from "devextreme-react/form";
import { CheckBox } from "devextreme-react/check-box";
import {
  DataGrid,
  Column,
  Paging,
  Pager,
  Selection,
} from "devextreme-react/data-grid";
import "devextreme-react/text-area";
import UserInfo from "../../UserInfo";
import {
  criarContribuinteDs,
  criarImovelDs,
  criarParametrosRefisDs,
  criarMotivoIsencaoIptuDs,
  criarMotivoPorTipoDs,
  criarLoteamentoDs
} from "../../DataSources";
import api from "../../api-axios";
import { Button, LoadIndicator, ScrollView } from "devextreme-react";
import sysCodigoDescricao from "../../components/sysCodigoDescricao";
import ContribuinteBox from "../contribuintes/ContribuinteBox";
import ImovelBox from "../imovel/ImovelBox";
import { Popup, ToolbarItem } from "devextreme-react/popup";
import DataSource from "devextreme/data/data_source";
import uiInfo from "../../ui-info";
import { TabPanel, Item } from "devextreme-react/tab-panel";
import "./NegociacaoDiat.css";
import "../../index.css";
import openReport from "../../openReport";
import ShowError from "../../AppServices";
import { TreeListHeaderFilter } from "devextreme-react/tree-list";
import showReport from "../../showReport";
import apiReports from "../../api-reports";

const template = {
  id: undefined,
  prefeituraId: UserInfo.getPrefeitura(),
  _uiMaisFiltros: false,
  tipoPeriodo: 0,
  natureza: 0,
  origens: "",
  leisParcelamento: [],
  permiteDadosManuais: false,
  permiteEntradaManual: false,
  permiteDescontoManualSobrePrincipal: false,
  index: 0,
  _uiNomeContribuinte: "",
  _uiNomeImovel: "",
  dadosManuais: {
    tipoDescontoPrincipal: 0,
    descontoPrincipal: 0,
    tipoDescontoMulta: 0,
    descontoMulta: 0,
    tipoDescontoJuros: 0,
    descontoJuros: 0,
    tipoDescontoCorrecao: 0,
    descontoCorrecao: 0,
    qtdeMaxParcelas: 1,
  },
  contribuinteId: null,
  imovelId: null,
  loteamentoId: 0,
  refisId: null,
  valorEntrada: 0,
  amortizacao: 0,
  motivoAmortizacao: "",
  qtdeParcelas: 1,
  qtdeCreditos: 0,
  valorTotal: 0,
  totalPrincipal: 0,
  totalMulta: 0,
  totalJuros: 0,
  totalCorrecao: 0,
  totalNegociacao: 0,
  percPrincipal: undefined,
  percMulta: undefined,
  percJuros: undefined,
  percCorrecao: undefined,
  valorPrincipal: undefined,
  valorMulta: undefined,
  valorJuros: undefined,
  valorCorrecao: undefined,
  primeiroVencimento: new Date(),
  valorParcela1: null,
  usaRefis: false,
  primeiraParcela: false,
  popupContribuinteVisivel: false,
  popupImovelVisivel: false,
  popupAcordo: false,
  diatDs: [],
  historico: [],
  msgRefis: undefined,
  exibirMsgRefis: false,
  tabSelected: 1,
  etapa: 1,
  verParcela: false,
  verDadosManuais: false,
  simulacoes: [],
  dividasSelecionadas: [],
  parcelas: [],
  finalDetalhado: false,
  tipoProcesso: 0,
  _uiLoteamentos: [
    { id: -1, descricao: "<SEM LOTEAMENTO>" },
    { id: 0, descricao: " " }
  ],
  situacaoAcordo: 2,
  _uiSituacaoAcordo: [
    { id: 0, descricao: "TODOS" },
    { id: 1, descricao: "ACORDADAS" },
    { id: 2, descricao: "NAO ACORDADAS" }
  ]
};

export default class NegociacaoDiat extends React.Component {
  constructor(props) {
    super(props);
    this.saidaProgramada = false;
    template.prefeituraId = UserInfo.getPrefeitura();
    this.cancel = this.cancel.bind(this);
    this.state = {
      _uiMsgCarregamento: "",
      _uiMaisFiltros: false,
      tipoPeriodo: 0,
      natureza: 0,
      origens: "",
      dadosManuais: {
        tipoDescontoPrincipal: 0,
        descontoPrincipal: 0,
        tipoDescontoMulta: 0,
        descontoMulta: 0,
        tipoDescontoJuros: 0,
        descontoJuros: 0,
        tipoDescontoCorrecao: 0,
        descontoCorrecao: 0,
        qtdeMaxParcelas: 1,
      },
      dividasSelecionadas: []
    };
    this.contribuinteDs = criarContribuinteDs();
    this.imovelDs = criarImovelDs();
    this.updateGrid = this.updateGrid.bind(this);
    this.onSelection = this.onSelection.bind(this);
    this.atualizarDadosSegundaEtapa =
      this.atualizarDadosSegundaEtapa.bind(this);
    this.finalizarAcordo = this.finalizarAcordo.bind(this);
    this.atualizandoDadosSegundaEtapa = false;

    this.passarSegundaEtapa = this.passarSegundaEtapa.bind(this);
    this.printReport = this.printReport.bind(this);
    this.printTermoConfissao = this.printTermoConfissao.bind(this);
    this.printDams = this.printDams.bind(this);
    this.cencelarAcordo = this.cencelarAcordo.bind(this);

    this.parametrosRefis = [];
    this._gridInstance = React.createRef();
    this._gridParcelasInstance = React.createRef();
    this.filtroCorrente = [];

    this.refisOptions = {
      editorType: "dxSelectBox",
      dataSource: this.state.leisParcelamento,
      valueExpr: "id",
      displayExpr: "descricao",
      searchMode: "contains",
      onValueChanged: (e) => {
        this.setState({ refisId: e.value });
        this.updateGrid(null, null, e.value, null);
      },
    };

    this.processoOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: [
        { id: 0, descricao: " " },
        { id: 1, descricao: "CANCELAMENTO" },
        { id: 2, descricao: "PRESCRIÇÃO" },
        { id: 3, descricao: "REMISSÃO" },
        { id: 4, descricao: "ISENÇÃO" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
      onValueChanged: (e) => {
        if (e) {
          console.log("e", e);
          this.setState({ tipoProcesso: e.value });

        }
      }
    };

    this.onTipoPeriodoAlterado = this.onTipoPeriodoAlterado.bind(this);

    this.tipoPeriodoOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: [
        { id: 0, descricao: "TODOS" },
        { id: 1, descricao: "EXERCICIO - ULTIMOS 5 ANOS" },
        { id: 4, descricao: "EXERCICIO - CUSTOMIZADO" },
        { id: 2, descricao: "VENCIMENTO - ULTIMOS 5 EXERCÍCIOS" },
        { id: 3, descricao: "VENCIMENTO - ULTIMOS 5 ANOS" },
        { id: 5, descricao: "VENCIMENTO - ANO CUSTOMIZADO" },
      ],
      placeholder: " ",
      valueExpr: "id",
      displayExpr: "descricao",
      showClearButton: false,
      onValueChanged: this.onTipoPeriodoAlterado
    };

    this.naturezaOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: [
        { id: 0, descricao: " " },
        { id: 1, descricao: "TRIBUTARIA" },
        { id: 2, descricao: "NAO TRIBUTARIA" }
      ],
      placeholder: " ",
      valueExpr: "id",
      displayExpr: "descricao",
      showClearButton: false,
    };

    this.motivoCancelamentoDs = criarMotivoPorTipoDs(3);

    this.motivoCancelamentoOptions = {
      editorType: "dxLookup",
      searchEnabled: true,
      dataSource: this.motivoCancelamentoDs,
      valueExpr: "id",
      displayExpr: "descricao",
    };

    this.motivoRemissaoDs = criarMotivoPorTipoDs(4);

    this.motivoRemissaoOptions = {
      editorType: "dxLookup",
      searchEnabled: true,
      dataSource: this.motivoRemissaoDs,
      valueExpr: "id",
      displayExpr: "descricao",
    };

    this.motivoIsencaoDs = criarMotivoPorTipoDs(5);

    this.motivoIsencaoOptions = {
      editorType: "dxLookup",
      searchEnabled: true,
      dataSource: this.motivoIsencaoDs,
      valueExpr: "id",
      displayExpr: "descricao",
    };


    //Funções do contribuinte
    /*
    /*
    */
    this.setContribuinteId = this.setContribuinteId.bind(this);
    this.setNomeContribuinte = this.setNomeContribuinte.bind(this);
    this.pesquisarContribuinte = this.pesquisarContribuinte.bind(this);
    this.onContribuinteSelecionadoPesquisa =
      this.onContribuinteSelecionadoPesquisa.bind(this);
    this.contribuinteBoxRef = React.createRef();
    this.renderContribuinte = sysCodigoDescricao(
      () => this.state.contribuinteId,
      this.setContribuinteId,
      () => this.state._uiNomeContribuinte,
      this.pesquisarContribuinte
    );
    this.setNomeContribuinteErro = this.setNomeContribuinteErro.bind(this);
    this.atualizarNomeContribuinte = this.atualizarNomeContribuinte.bind(this);
    /*
    /*
    */
    //Fim da funções do contribuinte

    //Funções do imóvel
    /*
    /*
    */
    this.setImovelId = this.setImovelId.bind(this);
    this.setNomeImovel = this.setNomeImovel.bind(this);
    this.pesquisarImovel = this.pesquisarImovel.bind(this);
    this.onImovelSelecionadoPesquisa =
      this.onImovelSelecionadoPesquisa.bind(this);
    this.renderImovel = sysCodigoDescricao(
      () => this.state.imovelId,
      this.setImovelId,
      () => this.state._uiNomeImovel,
      this.pesquisarImovel
    );
    this.setNomeImovelErro = this.setNomeImovelErro.bind(this);
    this.atualizarNomeImovel = this.atualizarNomeImovel.bind(this);
    this.setStateSync = this.setStateSync.bind(this);
    /*
   /*
   */
    //Fim da funções do imóvel

    this.confirmarProcedimento = this.confirmarProcedimento.bind(this);
    this.maisFiltros = this.maisFiltros.bind(this);
    this.limparFiltros = this.limparFiltros.bind(this);

  }

  maisFiltros() {
    this.setState({ _uiMaisFiltros: !this.state._uiMaisFiltros })
  }

  limparFiltros() {
    this.setState({
      contribuinteId: null,
      _uiNomeContribuinte: "",
      imovelId: null,
      _uiNomeImovel: "",
      tipoPeriodo: 0,
      periodoCustomizado: "",
      origens: "",
      natureza: 0
    });
  }

  onTipoPeriodoAlterado(e) {
    console.log("tipo", e);
    this.setState({ tipoPeriodo: e.value })
  }

  async confirmarProcedimento() {

    await this.setStateSync({ _uiCarregando: true });

    let motivoId = this.state.motivoProcessoCancelamento;

    if (this.state.tipoProcesso == 3) {
      motivoId = this.state.motivoProcessoRemissao;
    }
    if (this.state.tipoProcesso == 4) {
      motivoId = this.state.motivoProcessoIsencao;
    }

    const diats = this.state.dividasSelecionadas ?? [];
    const diatsIds = diats.map(d => d.dividaId);
    console.log(diatsIds);

    const entidade = {
      prefeituraId: UserInfo.getPrefeitura(),
      contribuinteSeq: this.state.contribuinteId,
      tipo: this.state.tipoProcesso,
      motivoId: motivoId,
      fundamento: this.state.fundamentoProcesso,
      obs: this.state.obs,
      diatsIds: diatsIds
    };

    try {
      const resp = await api.post(`/diat/procedimento`, entidade);

      console.log(resp);

      const data = resp.data;

      if (data.sucesso) {
        notify("Procedimento realizado com sucesso", "success");
        await this.setStateSync({
          popupProcessoVisível: false, tipoProcesso: 0,
          motivoProcessoCancelamento: null,
          motivoProcessoRemissao: null,
          motivoProcessoIsencao: null,
          fundamentoProcesso: "",
          obs: ""
        });
        this.updateGrid(this.state.contribuinteId, this.state.imovelId);

      }
      else {
        ShowError([data.msgErro]);
      }
    }
    catch (error) {
      notify(error, "error");
    }


  }


  //Funções do contribuinte
  /*
  /*
  */

  setContribuinteId(data) {
    this.setState({ contribuinteId: data.value });
    this.atualizarNomeContribuinte();
    // this.updateGrid(data.value, null);
  }

  async updateGrid(contribuinte, imovel) {


    const request = {
      prefeituraId: UserInfo.getPrefeitura(),
      contribuinteId: this.state.contribuinteId,
      imovelId: this.state.imovelId,
      tipoPeriodo: this.state._uiMaisFiltros ? this.state.tipoPeriodo : 0,
      periodoCustomizado: this.state._uiMaisFiltros ? this.state.periodoCustomizado : "",
      origens: this.state._uiMaisFiltros ? this.state.origens : "",
      natureza: this.state._uiMaisFiltros ? this.state.natureza : 0,
      loteamentoId: this.state.loteamentoId,
      situacaoAcordo: this.state.situacaoAcordo
    };

    await this.setStateSync({ _uiMsgCarregamento: "Buscando dados..." });

    try {

      const response = await api.post("/lancamentos/start_acordos", request);

      const historico =
        response && response.data && response.data.historico
          ? response.data.historico
          : [];
      const diats =
        response && response.data && response.data.diats
          ? [...response.data.diats]
          : [];
      const leis =
        response && response.data && response.data.diats
          ? [...response.data.leisParcelamento]
          : [];
      console.log("leis", leis);

      this.parametrosRefis = leis;

      console.log("store", this.parametrosRefis);

      const permiteEntradaManual = response && response.data && response.data.permiteEntradaManual ? true : false;


      return this.setState({
        leisParcelamento: leis,
        historico: historico,
        diatDs: diats,
        permiteEntradaManual
      });

    }
    catch (error) {
      console.log("error json", error.toJSON());
      console.log(
        "error",
        error,
        "error.data",
        error.data,
        "error.response",
        error.response
      );

      if (
        error.response &&
        error.response.data &&
        error.response.data.erros
      ) {
        ShowError(error.response.data.erros);
      } else if (error.response) {
        ShowError(error.response.statusText);
      } else {
        ShowError(error);
      }
    }
    finally {
      this.setStateSync({ _uiMsgCarregamento: "" })
    }


  }

  atualizarNomeContribuinte() {
    this.contribuinteDs
      .load({ filter: [["sequencial", "=", this.state.contribuinteId]] })
      .then((result) => {
        if (result.length !== 0) {
          this.setNomeContribuinte(result[0]);
        } else {
          this.setNomeContribuinte(undefined);
        }
      })
      .catch((_) => this.setNomeContribuinteErro());
  }

  setNomeContribuinte(contribuinte) {
    if (contribuinte === undefined) {
      this.setState({ _uiNomeContribuinte: "" });
    } else {
      this.setState({ _uiNomeContribuinte: contribuinte.nome });
    }
  }

  setNomeContribuinteErro() {
    this.setState({ _uiNomeContribuinte: "<<ERRO>>" });
  }

  onContribuinteSelecionadoPesquisa(e) {
    this.setState({
      contribuinteId: e.row.data.sequencial,
      popupContribuinteVisivel: false,
    });
    this.atualizarNomeContribuinte();
    this.updateGrid(e.row.data.sequencial, null);
  }

  pesquisarContribuinte() {
    this.contribuinteBoxRef.current.limparFiltro();
    this.setState({ popupContribuinteVisivel: true });
  }
  /*
  /*
  */
  //Fim da funções do contribuinte

  //Funções do imóvel
  /*
  /*
  */

  async setImovelId(data) {
    this.setState({ imovelId: data.value });
    this.atualizarNomeImovel();
    // this.updateGrid(null, data.value);
  }

  atualizarNomeImovel() {
    this.imovelDs
      .load({ filter: [["sequencial", "=", this.state.imovelId]] })
      .then((result) => {
        if (result.length !== 0) {
          this.setNomeImovel(result[0]);
        } else {
          this.setNomeImovel(undefined);
        }
      })
      .catch((_) => this.setNomeImovelErro());
  }

  setNomeImovel(imovel) {
    if (imovel === undefined) {
      this.setState({ _uiNomeImovel: "" });
    } else {
      this.setState({ _uiNomeImovel: imovel.enderecoCompleto });
    }
  }

  setNomeImovelErro() {
    this.setState({ _uiNomeImovel: "<<ERRO>>" });
  }

  onImovelSelecionadoPesquisa(e) {
    this.setState({
      imovelId: e.row.data.sequencial,
      popupImovelVisivel: false,
    });
    this.atualizarNomeImovel();
    this.updateGrid(null, e.row.data.sequencial);
  }

  pesquisarImovel() {
    this.setState({ popupImovelVisivel: true });
  }
  /*
/*
*/
  //Fim da funções do imóvel

  async onSelection({ selectedRowsData }) {
    this.setState({
      dividasSelecionadas: selectedRowsData,
    });
  }

  async passarSegundaEtapa() {
    if (this.state.dividasSelecionadas.length > 0) {
      try {
        const response = await api.post("/lancamentos/etapa2_acordos", {
          prefeituraId: this.state.prefeituraId,
          diats: this.state.dividasSelecionadas,
        });
        if (response.data !== null && response.data !== undefined) {
          this.setState({ etapa: 2, ...response.data });
        }
      } catch (error) {
        console.log(error);
      }
    } else {
      notify("Nenhuma dívida selecionada.", "error", 4000);
    }
  }

  async passarTerceiraEtapa() {
    try {
      var date = this.state.primeiroVencimento;
      var dia = date.getDate(); // yields date
      var mes = date.getMonth() + 1; // yields month (add one as '.getMonth()' is zero indexed)
      var ano = date.getFullYear(); // yields year

      console.log(this.state);

      const response = await api.post("/lancamentos/etapa3_acordos", {
        prefeituraId: this.state.prefeituraId,
        diats: this.state.dividasSelecionadas,
        primeiroVencimento: this.state.primeiroVencimento,
        valorEntrada: this.state.valorEntrada,
        refisId: this.state.refisId,
        amortizacao: this.state.amortizacao,
        motivoAmortizacao: this.state.motivoAmortizacao,

        dadosManuais: this.state.verDadosManuais
          ? this.state.dadosManuais
          : null,
        dia,
        mes,
        ano,
      });
      if (response.data !== null && response.data !== undefined) {
        if (response.data.sucesso) {
          this.setState({ etapa: 3, simulacoes: response.data.simulacoes });
        }
        else {
          console.log("erro detalhado", response.data);
          ShowError(response.data.erros);
        }


      }
    } catch (error) {
      notify("Erro desconhecido", "error");
    }
  }

  setStateSync(state) {
    return new Promise(resolve => {
      this.setState(state, resolve)
    })
  }

  async finalizarAcordo(e) {

    if (this.state._uiProcessando) {
      return;
    }

    await this.setStateSync({ _uiProcessando: true });

    try {

      var request = {
        prefeituraId: this.state.prefeituraId,
        contribuinteId: this.state.contribuinteId,
        simulacao: { ...e.row.data },
      };

      const response = await api.post("/lancamentos/finalizar_acordos", request);

      if (response.data !== null && response.data !== undefined) {
        let recoverData = {
          contribuinteId: this.state.contribuinteId,
          imovelId: this.state.imovelId,
          _uiNomeContribuinte: this.state._uiNomeContribuinte,
          _uiNomeImovel: this.state._uiNomeImovel,
        };
        this.updateGrid(this.state.contribuinteId, this.state.imovelId);
        this.setState({
          ...template,
          etapa: 1,
          index: 1,
          ...recoverData,
          _uiProcessando: false
        });
      }
    } catch (error) {
      ShowError(error.response.data);
      notify(error, "error", 2000);
      this.setState({ _uiProcessando: false });
    }
  }

  async atualizarDadosSegundaEtapa(comando, paramNum, paramData) {
    if (this.atualizandoDadosSegundaEtapa) {
      return;
    }
    if (paramNum !== undefined) {
      const response = await api.post("/lancamentos/etapa2_acordos", {
        prefeituraId: this.state.prefeituraId,
        parametro: {
          comando: comando,
          valorParametroNumerico: paramNum,
          valorParametroData: paramData,
        },
        corrente: {
          refisId: this.state.refisId,
          totalPrincipal: this.state.totalPrincipal,
          totalMulta: this.state.totalMulta,
          totalJuros: this.state.totalJuros,
          totalCorrecao: this.state.totalCorrecao,
          percPrincipal: this.state.percPrincipal,
          percMulta: this.percMulta,
          percJuros: this.state.percJuros,
          percCorrecao: this.state.percCorrecao,
          valorPrincipal: this.state.valorPrincipal,
          valorMulta: this.state.valorMulta,
          valorJuros: this.state.valorJuros,
          valorCorrecao: this.state.valorCorrecao,
          valorAmortizacao: this.state.valorAmortizacao,
          qtdeParcelas: this.state.qtdeParcelas,
          dataParcela1: this.state.dataParcela1,
          valorParcela1: this.state.valorParcela1,
          totalNegociacao: this.state.totalNegociacao,
        },
      });
      if (response.data !== null) {
        this.atualizandoDadosSegundaEtapa = true;
        this.setState({ ...response.data });
        this.atualizandoDadosSegundaEtapa = false;
      }
    }
  }

  async printReport(flag) {
    try {
      const response = await apiReports.post(
        `/report/simulacao_acordos/${UserInfo.getPrefeitura()}/${flag}`,
        this.state.simulacoes
      );
      if (
        response.status === 200 &&
        response.data !== null &&
        response.data !== undefined
      ) {
        openReport(response.data.value);
      }
    } catch (error) {
      ShowError(error.response.data);
      notify(error, "error", 2000);
    }
  }

  async printTermoConfissao(rowData) {
    await showReport(`/report/termo_confissao/${rowData.acordoId}/${UserInfo.getPrefeitura()}`);
  }

  async printDams(rowData) {
    await showReport(`/report/dam_parcelamento_id/${rowData.acordoId}/${UserInfo.getPrefeitura()}/false`);
  }

  async cencelarAcordo(rowData) {
    try {
      const response = await api.put(
        `/lancamentos/cancelar_acordo/${rowData.acordoId
        }/${UserInfo.getPrefeitura()}`
      );
      console.log(response);
      if (response.status === 200) {
        this.updateGrid(this.state.contribuinteId, null);
      }
    } catch (error) {
      ShowError(error.response.data);
      notify(error, "error", 2000);
    }
  }

  componentDidMount() {

    criarParametrosRefisDs()
      .load()
      .then((data) => {
        data.map((x) => {
          this.parametrosRefis.push(x);
        });
      });

    const listaLoteamentos = [...template._uiLoteamentos];

    criarLoteamentoDs()
      .load()
      .then(data => {
        console.log("loteamentos", data);
        data.forEach(element => {
          listaLoteamentos.push(element);
        });
        console.log("loteamentos", listaLoteamentos);
        this.setState({ _uiLoteamentos: listaLoteamentos });
      });

    this.setState({ ...template });
  }

  render() {

    if (this.state._uiMsgCarregamento != "") {
      return (
        <>
          <div
            className={"content-block dx-card responsive-paddings"}
            style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
            <LoadIndicator width={60} height={60} />
            <h3>{this.state._uiMsgCarregamento}</h3>
          </div>
        </>
      );
    }




    return (
      <React.Fragment>
        <div
          className={"content-block dx-card responsive-paddings"}
          style={{ display: this.state.etapa === 1 ? "" : "none" }}
        >
          <form>
            <Form formData={this.state} colCount={3}>
              <GroupItem caption="" colSpan={3} colCount={4}>
                <GroupItem
                  caption="NEGOCIAÇÃO DE DÍVIDA ATIVA"
                  colSpan={4}
                  colCount={8}
                >
                  <SimpleItem 
                    colSpan={8}
                    isRequired={true}
                    component={this.renderContribuinte}
                  >
                    <Label text="Contribuinte" />
                  </SimpleItem>
                  
                  <SimpleItem colSpan={8} component={this.renderImovel}>
                    <Label text="Imóvel" />
                  </SimpleItem>
                  
                  <SimpleItem colSpan={this.state.tipoPeriodo > 3 ? 3 : 8} dataField={"tipoPeriodo"}
                    editorType={"dxSelectBox"}
                    editorOptions={this.tipoPeriodoOptions} visible={this.state._uiMaisFiltros}>

                    <Label text="Período" />
                  </SimpleItem>
                  
                  <SimpleItem dataField={"periodoCustomizado"} visible={this.state.tipoPeriodo > 3 && this.state._uiMaisFiltros}
                    colSpan={5} helpText={"Ex.: 2018, 2019, 2022-2023"}>
                    <Label text="Período Customizado" />
                  </SimpleItem>

                  <SimpleItem dataField={"origens"} colSpan={4} helpText={"Ex.: IPTU, TLLF"} visible={this.state._uiMaisFiltros}>
                    <Label text="Origem" />
                  </SimpleItem>
                  <SimpleItem colSpan={4} dataField={"natureza"}
                    editorType={"dxSelectBox"}
                    editorOptions={this.naturezaOptions}
                    visible={this.state._uiMaisFiltros}>
                    <Label text="Natureza" />
                  </SimpleItem>
                  <SimpleItem colSpan={4} dataField={"loteamentoId"}
                    editorType={"dxSelectBox"}
                    editorOptions={{
                      editorType: "dxSelectBox",
                      searchEnabled: false,
                      dataSource: this.state._uiLoteamentos,
                      placeholder: " ",
                      valueExpr: "id",
                      displayExpr: "descricao",
                      showClearButton: false,
                    }}
                    visible={this.state._uiMaisFiltros}>
                    <Label text="Loteamento" />
                  </SimpleItem>
                  <SimpleItem colSpan={4} dataField={"situacaoAcordo"}
                    editorType={"dxSelectBox"}
                    editorOptions={{
                      disabled: !UserInfo.eSuporte(),
                      editorType: "dxSelectBox",
                      searchEnabled: false,
                      dataSource: this.state._uiSituacaoAcordo,
                      placeholder: " ",
                      valueExpr: "id",
                      displayExpr: "descricao",
                      showClearButton: false,
                    }}
                    visible={this.state._uiMaisFiltros}>
                    <Label text="Situação do Acordo" />
                  </SimpleItem>
                  <EmptyItem colSpan={5} />
                  <ButtonItem buttonOptions={{ text: "Filtrar", type: "success", width: "100%", onClick: this.updateGrid }} />
                  <ButtonItem buttonOptions={{ text: this.state._uiMaisFiltros ? "Menos filtros" : "Mais filtros", width: "100%", onClick: this.maisFiltros }} />
                  <ButtonItem buttonOptions={{ text: "Limpar", width: "100%", onClick: this.limparFiltros }} />
                </GroupItem>
              </GroupItem>
            </Form>
            <br />
            <TabPanel
              selectedIndex={this.state.index}
              onTitleClick={(e) => this.setState({ index: e.itemIndex })}
            >
              <Item title="NOVO ACORDO">
                <br />
                <div className="tabItems">
                  <DataGrid
                    ref={(grid) => (this._gridInstance = grid)}
                    dataSource={this.state.diatDs}
                    showBorders={true}
                    rowAlternationEnabled={true}
                    remoteOperations={true}
                    columnAutoWidth={true}
                    wordWrapEnabled={window.innerWidth < 800}
                    headerFilter={{ visible: false }}
                    filterRow={{ visible: false }}
                    onSelectionChanged={(e) => this.onSelection(e)}
                    paging={false}
                  >
                    <Selection
                      mode="multiple"
                      selectAllMode="allPages"
                      showCheckBoxesMode="always"
                    />
                    <Column
                      dataField={"id"}
                      allowEditing={false}
                      alignment={"center"}
                      visible={false}
                    />
                    <Column
                      dataField={"dividaSequencial"}
                      caption={"#"}
                      allowEditing={false}
                      visibleIndex={1}
                      width={100}
                      alignment={"center"}
                    />
                    <Column
                      dataField={"ano"}
                      caption={"Exercício"}
                      alignment={"center"}
                      visibleIndex={2}
                      width={120}
                      sortIndex={1}
                      sortOrder={"desc"}
                    />
                    <Column
                      dataField={"origem"}
                      caption={"Origem"}
                      visibleIndex={3}
                      width={100}
                    />
                    <Column
                      dataField={"tributario"}
                      caption={"Tributária"}
                      visibleIndex={4}
                      width={100}
                    />
                    <Column
                      dataField={"situacao"}
                      caption={"Situacao"}
                      visibleIndex={5}
                      width={150}
                    />
                    <Column
                      dataField={"vencimento"}
                      dataType="date"
                      caption={"Vencimento"}
                      visibleIndex={6}
                      width={120}
                      sortIndex={2}
                      sortOrder={"desc"}
                    />
                    <Column
                      dataField={"valorOriginal"}
                      caption={"Vr. Original"}
                      format={{ type: "fixedPoint", precision: 2 }}
                      visibleIndex={7}
                      width={120}
                    />
                    <Column
                      dataField={"multa"}
                      caption={"Multa"}
                      format={{ type: "fixedPoint", precision: 2 }}
                      visibleIndex={8}
                      width={120}
                    />
                    <Column
                      dataField={"juros"}
                      caption={"Juros"}
                      format={{ type: "fixedPoint", precision: 2 }}
                      visibleIndex={9}
                      width={120}
                    />
                    <Column
                      dataField={"correcao"}
                      caption={"Correção"}
                      format={{ type: "fixedPoint", precision: 2 }}
                      visibleIndex={10}
                      width={120}
                    />
                    <Column
                      dataField={"total"}
                      caption={"Total"}
                      format={{ type: "fixedPoint", precision: 2 }}
                      visibleIndex={11}
                      width={120}
                    />
                    <Column
                      dataField={"imovelId"}
                      caption={"Imóvel"}
                      visibleIndex={12}
                    />
                    <Column
                      dataField={"endereco"}
                      caption={"Endereço"}
                      visibleIndex={13}
                    />
                    <Column
                      dataField={"processo"}
                      caption={"Processo"}
                      visibleIndex={14}
                    />
                    <Column
                      dataField={"acordao"}
                      caption={"Acordão"}
                      visibleIndex={15}
                      allowHiding
                    />
                    <Column
                      dataField={"receita"}
                      caption={"Receita"}
                      visibleIndex={16}
                      allowHiding
                    />
                  </DataGrid>
                  <br />
                  <br />
                </div>
              </Item>
              <Item
                title={`ACORDOS EXISTENTES ( ${this.state.historico === undefined
                  ? 0
                  : this.state.historico.length
                  } )`}
              >
                <div className="tabItems">
                  <br />
                  <DataGrid
                    dataSource={this.state.historico}
                    showBorders={true}
                    rowAlternationEnabled={true}
                    remoteOperations={true}
                    columnAutoWidth={true}
                    columnHidingEnabled={true}
                    wordWrapEnabled={window.innerWidth < 800}
                  >
                    <Column
                      type="buttons"
                      fixed={true}
                      fixedPosition={"left"}
                      caption=""
                      width={110}
                      buttons={[
                        {
                          icon: "exportpdf",
                          text: "Termo do Acordo",
                          onClick: (e) => this.printTermoConfissao(e.row.data),
                        },
                        {
                          icon: "money",
                          text: "DAMs",
                          onClick: (e) => this.printDams(e.row.data),
                        },
                        {
                          icon: "remove",
                          text: "Cancelar Acordo",
                          onClick: (e) => this.cencelarAcordo(e.row.data),
                        },
                      ]}
                    />

                    <Column
                      alignment={"center"}
                      dataField={"data"}
                      caption={"Data"}
                      dataType="date"
                      width={120}
                    />
                    <Column
                      alignment={"center"}
                      dataField={"numeroAcordo"}
                      caption={"#"}
                      width={120}
                    />
                    <Column
                      dataField={"situacao"}
                      caption={"Situação"}
                      width={150}
                    />
                    <Column dataField={"receita"} caption={"Receita"} />
                    <Column
                      dataField={"natureza"}
                      caption={"Natureza"}
                    />
                    <Column dataField={"parcelas"} caption={"Parcelas"} />
                    <Column
                      dataField={"parcelasPagas"}
                      caption={"Parcelas Pagas"}
                    />
                    <Column dataField={"imovelId"} caption={"Cod. Imóvel"} />
                    <Column dataField={"imovelEndereco"} caption={"Endereço"} />
                    <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
                    <Pager
                      showPageSizeSelector={true}
                      allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
                    />
                  </DataGrid>
                </div>
              </Item>
            </TabPanel>
            {this.state.exibirMsgRefis ? <p>{this.state.msgRefis}</p> : null}
            <br />
            <br />
            <div
              style={{
                display: "flex",
                marginTop: "25px",
                justifyContent: "center",
                alignContent: "center",
                justifyItems: "center",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <Button
                width={150}
                text={`Processos ( ${this.state.dividasSelecionadas
                  ? this.state.dividasSelecionadas.length
                  : 0
                  } )`}
                type="normal"
                disabled={
                  this.state.dividasSelecionadas.length > 0 ? false : true
                }
                onClick={() => this.setState({ popupProcessoVisível: true })}
              />
              <Button
                width={150}
                text="Emitir Notificação"
                type="default"
                onClick={this.ok}
              />
              <Button
                width={150}
                text="Prosseguir"
                type="success"
                onClick={() => this.passarSegundaEtapa()}
              />
              <div style={{ display: "none", marginLeft: "10px" }}>
                <Button text="Cancelar" onClick={this.cancel} width={120} />
              </div>
            </div>
          </form>
          <Popup
            visible={this.state.popupContribuinteVisivel}
            onHiding={() => this.setState({ popupContribuinteVisivel: false })}
            dragEnabled={false}
            closeOnOutsideClick={false}
            showCloseButton={false}
            showTitle={true}
            width={"90%"}
            height={"90%"}
            title="Pesquisar Contribuinte"
          >
            <ScrollView showScrollbar={"always"}>
              <ContribuinteBox
                onSelecionado={this.onContribuinteSelecionadoPesquisa}
                ref={this.contribuinteBoxRef}
              />
            </ScrollView>
            <ToolbarItem
              toolbar={"bottom"}
              widget="dxButton"
              location="center"
              options={{
                text: "Fechar",
                type: "default",
                width: 150,
                onClick: () =>
                  this.setState({ popupContribuinteVisivel: false }),
              }}
            ></ToolbarItem>
          </Popup>
          <Popup
            visible={this.state.popupImovelVisivel}
            onHiding={() => this.setState({ popupImovelVisivel: false })}
            dragEnabled={false}
            closeOnOutsideClick={false}
            showCloseButton={false}
            showTitle={true}
            width={"90%"}
            height={"90%"}
            title="Pesquisar Imóvel"
          >
            <ScrollView showScrollbar={"always"}>
              <ImovelBox onSelecionado={this.onImovelSelecionadoPesquisa} />
            </ScrollView>
            <ToolbarItem
              toolbar={"bottom"}
              widget="dxButton"
              location="center"
              options={{
                text: "Fechar",
                type: "default",
                width: 150,
                onClick: () => this.setState({ popupImovelVisivel: false }),
              }}
            ></ToolbarItem>
          </Popup>
          <Popup
            visible={this.state.popupAcordo}
            onHiding={() => this.setState({ popupAcordo: false })}
            dragEnabled={false}
            closeOnOutsideClick={true}
            showCloseButton={true}
            showTitle={true}
            width={"70%"}
            height={"70%"}
            title="Novo acordo"
          ></Popup>
          <Popup
            visible={this.state.popupProcessoVisível}
            onHiding={() => this.setState({ popupProcessoVisível: false })}
            dragEnabled={false}
            closeOnOutsideClick={false}
            showCloseButton={false}
            showTitle={true}
            width={"90%"}
            height={"90%"}
            title="Procedimento"
          >
            <ScrollView showScrollbar={"always"}>
              <div className={"content-block dx-card responsive-paddings"}>
                <Form formData={this.state} colCount={2}>
                  <GroupItem colSpan={2} colCount={2}>
                    <SimpleItem
                      colSpan={2}
                      dataField="tipoProcesso"
                      editorType={"dxSelectBox"}
                      editorOptions={this.processoOptions}
                    >
                      <Label text="Processo" />
                    </SimpleItem>
                    <SimpleItem
                      colSpan={2}
                      dataField="motivoProcessoCancelamento"
                      editorType={"dxLookup"}
                      editorOptions={this.motivoCancelamentoOptions}
                      visible={this.state.tipoProcesso == 1}
                    >
                      <Label text="Motivo" />
                    </SimpleItem>

                    <SimpleItem
                      colSpan={2}
                      dataField="motivoProcessoRemissao"
                      editorType={"dxLookup"}
                      editorOptions={this.motivoRemissaoOptions}
                      visible={this.state.tipoProcesso == 3}
                    >
                      <Label text="Motivo" />
                    </SimpleItem>

                    <SimpleItem
                      colSpan={2}
                      dataField="motivoProcessoIsencao"
                      editorType={"dxLookup"}
                      editorOptions={this.motivoIsencaoOptions}
                      visible={this.state.tipoProcesso == 4}
                    >
                      <Label text="Motivo" />
                    </SimpleItem>

                    <SimpleItem
                      dataField={"fundamentoProcesso"}
                      colSpan={1}
                      editorType="dxTextArea"
                      editorOptions={{ height: 90 }}
                    >
                      <Label text="Fundamento" />
                    </SimpleItem>
                    <SimpleItem
                      dataField={"obs"}
                      colSpan={1}
                      editorType="dxTextArea"
                      editorOptions={{ height: 90 }}
                    >
                      <Label text="Observação" />
                    </SimpleItem>
                  </GroupItem>
                </Form>
                <br />
                <br />
                <DataGrid
                  width={"100%"}
                  dataSource={this.state.dividasSelecionadas}
                  showBorders={true}
                  rowAlternationEnabled={true}
                  remoteOperations={true}
                  columnAutoWidth={true}
                  wordWrapEnabled={window.innerWidth < 800}
                  headerFilter={{ visible: false }}
                  filterRow={{ visible: false }}
                >
                  <Column
                    dataField={"dividaSequencial"}
                    caption={"#"}
                    allowEditing={false}
                    visibleIndex={1}
                    width={100}
                    alignment={"center"}
                  />
                  <Column
                    dataField={"ano"}
                    caption={"Exercício"}
                    alignment={"center"}
                    visibleIndex={2}
                    width={120}
                    sortIndex={1}
                    sortOrder={"desc"}
                  />
                  <Column
                    dataField={"origem"}
                    caption={"Origem"}
                    visibleIndex={3}
                    width={100}
                  />
                  <Column
                    dataField={"vencimento"}
                    dataType="date"
                    caption={"Vencimento"}
                    visibleIndex={5}
                    width={120}
                    sortIndex={2}
                    sortOrder={"desc"}
                  />
                  <Column
                    dataField={"valorOriginal"}
                    caption={"Vr. Original"}
                    format={{ type: "fixedPoint", precision: 2 }}
                    visibleIndex={6}
                    width={120}
                  />
                  <Column
                    dataField={"multaTi"}
                    caption={"Multa"}
                    format={{ type: "fixedPoint", precision: 2 }}
                    visibleIndex={7}
                    width={120}
                  />
                  <Column
                    dataField={"jurosTi"}
                    caption={"Juros"}
                    format={{ type: "fixedPoint", precision: 2 }}
                    visibleIndex={8}
                    width={120}
                  />
                  <Column
                    dataField={"correcaoTi"}
                    caption={"Correção"}
                    format={{ type: "fixedPoint", precision: 2 }}
                    visibleIndex={9}
                    width={120}
                  />
                  <Column
                    dataField={"totalTi"}
                    caption={"Total"}
                    format={{ type: "fixedPoint", precision: 2 }}
                    visibleIndex={10}
                    width={120}
                  />
                </DataGrid>
              </div>
            </ScrollView>
            <ToolbarItem
              toolbar={"bottom"}
              widget="dxButton"
              location="center"
              options={{
                text: "Fechar",
                type: "default",
                width: 150,
                onClick: () => this.setState({ popupProcessoVisível: false }),
              }}
            />
            <ToolbarItem
              toolbar={"bottom"}
              widget="dxButton"
              location="center"
              options={{
                text: "Confirmar",
                type: "success",
                width: 150,
                onClick: this.confirmarProcedimento,
              }}
            />
          </Popup>
        </div>
        <div
          className={"content-block dx-card responsive-paddings"}
          style={{ display: this.state.etapa === 2 ? "" : "none" }}
        >
          <Form formData={this.state} colCount={3} labelLocation={"top"}>
            <GroupItem caption="NEGOCIAÇÃO DE DÍVIDA" colSpan={3} colCount={5}>
              <SimpleItem
                colSpan={3}
                dataField={"refisId"}
                editorType={"dxSelectBox"}
                editorOptions={{ ...this.refisOptions, dataSource: this.state.leisParcelamento }}
              >
                <Label text="Lei de Parcelamento" />
              </SimpleItem>
              <SimpleItem
                colSpan={2}
                editorType={"dxDateBox"}
                editorOptions={{
                  width: "100%",
                  onValueChanged: (e) => {
                    this.setState({ dataDeVencimento: e.value });
                  },
                }}
                dataField={"primeiroVencimento"}
              >
                <Label text="Primeiro Vencimento" />
              </SimpleItem>
              <SimpleItem
                colSpan={1}
                dataField={"valorEntrada"}
                editorType={"dxNumberBox"}
                cssClass="box-n2"
                editorOptions={{
                  readOnly: !this.state.permiteEntradaManual,
                  format: { type: "fixedPoint", precision: 2 },
                }}
                helpText={"Se a lei exigir valor mínimo maior ou parcelamento comum for mais vantajoso ao município será desconsiderado (Recomendamos não preencher o valor)"}
              >
                <Label text="Entrada (R$)" />
              </SimpleItem>
              <SimpleItem
                colSpan={1}
                dataField={"amortizacao"}
                editorType={"dxNumberBox"}
                cssClass="box-n2"
                editorOptions={{
                  format: { type: "fixedPoint", precision: 2 },
                }}
              >
                <Label text="Amortização (R$)" />
              </SimpleItem>
              <SimpleItem colSpan={3} dataField={"motivoAmortizacao"}>
                <Label text="Motivo da Amortização" />
              </SimpleItem>
            </GroupItem>
          </Form>
          <br />
          <div>
            <CheckBox
              text={
                this.state.permiteDadosManuais
                  ? "Parcelamento Manual"
                  : "Você não tem permissão para parcelar manualmente"
              }
              value={this.state.verDadosManuais}
              readOnly={!this.state.permiteDadosManuais}
              onValueChanged={() => {
                if (this.state.permiteDadosManuais) {
                  this.setState({
                    verDadosManuais: !this.state.verDadosManuais,
                  });
                } else {
                  notify(
                    "Você não tem permissão de parcelar manualmente",
                    "error",
                    2000
                  );
                }
              }}
            />
            {/* <Button
              text="Parcelamento Manual"
              type="success"
              onClick={() => {
                if (this.state.permiteDadosManuais) {
                  this.setState({
                    verDadosManuais: !this.state.verDadosManuais,
                  });
                } else {
                  notify(
                    "Você não tem permissão de parcelar manualmente",
                    "error",
                    2000
                  );
                }
              }}
            /> */}
          </div>
          <br />
          <div style={{ display: this.state.verDadosManuais ? "" : "none" }}>
            <Form
              formData={this.state.dadosManuais}
              colCount={3}
              labelLocation={"top"}
            >
              <GroupItem caption="DADOS MANUAIS" colSpan={3} colCount={4}>
                <SimpleItem
                  colSpan={1}
                  dataField={"tipoDescontoPrincipal"}
                  editorType={"dxLookup"}
                  editorOptions={{
                    readOnly: !this.state.permiteDescontoManualSobrePrincipal,
                    editorType: "dxSelectBox",
                    dataSource: [
                      { id: 0, descricao: "Por Percentual" },
                      { id: 1, descricao: "Por Valor" },
                    ],
                    valueExpr: "id",
                    displayExpr: "descricao",
                    onValueChanged: (e) =>
                      this.setState({
                        dadosManuais: {
                          ...this.state.dadosManuais,
                          tipoDescontoPrincipal: e.value,
                        },
                      }),
                  }}
                >
                  <Label text="Tipo de Desconto Principal" />
                </SimpleItem>
                <SimpleItem
                  colSpan={1}
                  dataField={"tipoDescontoMulta"}
                  editorType={"dxLookup"}
                  editorOptions={{
                    editorType: "dxSelectBox",
                    dataSource: [
                      { id: 0, descricao: "Por Percentual" },
                      { id: 1, descricao: "Por Valor" },
                    ],
                    valueExpr: "id",
                    displayExpr: "descricao",
                    onValueChanged: (e) =>
                      this.setState({
                        dadosManuais: {
                          ...this.state.dadosManuais,
                          tipoDescontoMulta: e.value,
                        },
                      }),
                  }}
                >
                  <Label text="Tipo de Desconto Multa" />
                </SimpleItem>
                <SimpleItem
                  colSpan={1}
                  dataField={"tipoDescontoJuros"}
                  editorType={"dxLookup"}
                  editorOptions={{
                    editorType: "dxSelectBox",
                    dataSource: [
                      { id: 0, descricao: "Por Percentual" },
                      { id: 1, descricao: "Por Valor" },
                    ],
                    valueExpr: "id",
                    displayExpr: "descricao",
                    onValueChanged: (e) =>
                      this.setState({
                        dadosManuais: {
                          ...this.state.dadosManuais,
                          tipoDescontoJuros: e.value,
                        },
                      }),
                  }}
                >
                  <Label text="Tipo de Desconto Juros" />
                </SimpleItem>
                <SimpleItem
                  colSpan={1}
                  dataField={"tipoDescontoCorrecao"}
                  editorType={"dxLookup"}
                  editorOptions={{
                    editorType: "dxSelectBox",
                    dataSource: [
                      { id: 0, descricao: "Por Percentual" },
                      { id: 1, descricao: "Por Valor" },
                    ],
                    valueExpr: "id",
                    displayExpr: "descricao",
                    onValueChanged: (e) =>
                      this.setState({
                        dadosManuais: {
                          ...this.state.dadosManuais,
                          tipoDescontoCorrecao: e.value,
                        },
                      }),
                  }}
                >
                  <Label text="Tipo de Desconto Correção" />
                </SimpleItem>
                <SimpleItem
                  colSpan={1}
                  dataField={"descontoPrincipal"}
                  editorType={"dxNumberBox"}
                  cssClass="box-n2"
                  editorOptions={{
                    readOnly: !this.state.permiteDescontoManualSobrePrincipal,
                    format:
                      this.state.dadosManuais.tipoDescontoPrincipal === 0
                        ? { type: "percent", precision: 2 }
                        : { type: "fixedPoint", precision: 2 },
                  }}
                >
                  <Label
                    text={`Desconto (${this.state.dadosManuais.tipoDescontoPrincipal === 0
                      ? "%"
                      : "R$"
                      })`}
                  />
                </SimpleItem>
                <SimpleItem
                  colSpan={1}
                  dataField={"descontoMulta"}
                  editorType={"dxNumberBox"}
                  cssClass="box-n2"
                  editorOptions={{
                    format:
                      this.state.dadosManuais.tipoDescontoMulta === 0
                        ? { type: "percent", precision: 2 }
                        : { type: "fixedPoint", precision: 2 },
                  }}
                >
                  <Label
                    text={`Desconto (${this.state.dadosManuais.tipoDescontoMulta === 0
                      ? "%"
                      : "R$"
                      })`}
                  />
                </SimpleItem>
                <SimpleItem
                  colSpan={1}
                  dataField={"descontoJuros"}
                  editorType={"dxNumberBox"}
                  cssClass="box-n2"
                  editorOptions={{
                    format:
                      this.state.dadosManuais.tipoDescontoJuros === 0
                        ? { type: "percent", precision: 2 }
                        : { type: "fixedPoint", precision: 2 },
                  }}
                >
                  <Label
                    text={`Desconto (${this.state.dadosManuais.tipoDescontoJuros === 0
                      ? "%"
                      : "R$"
                      })`}
                  />
                </SimpleItem>
                <SimpleItem
                  colSpan={1}
                  dataField={"descontoCorrecao"}
                  editorType={"dxNumberBox"}
                  cssClass="box-n2"
                  editorOptions={{
                    format:
                      this.state.dadosManuais.tipoDescontoCorrecao === 0
                        ? { type: "percent", precision: 2 }
                        : { type: "fixedPoint", precision: 2 },
                  }}
                >
                  <Label
                    text={`Desconto (${this.state.dadosManuais.tipoDescontoCorrecao === 0
                      ? "%"
                      : "R$"
                      })`}
                  />
                </SimpleItem>
                <SimpleItem
                  colSpan={1}
                  dataField={"parcelaFixa"}
                  editorType="dxCheckBox"
                >
                  <Label text="Parcela Fixa" />
                </SimpleItem>
                <EmptyItem colSpan={3} />
                <SimpleItem colSpan={1} dataField={"qtdeMaxParcelas"}>
                  <Label text="Quantidade Máxima de Parcelas" />
                </SimpleItem>
                <SimpleItem
                  colSpan={1}
                  dataField={"valorMinParcela"}
                  editorType={"dxNumberBox"}
                  cssClass="box-n2"
                  editorOptions={{
                    format: { type: "fixedPoint", precision: 2 },
                  }}
                >
                  <Label text="Valor Mínimo da Parcela" />
                </SimpleItem>
                <SimpleItem
                  colSpan={1}
                  dataField={"percMinEntrada"}
                  editorType={"dxNumberBox"}
                  cssClass="box-n2"
                  editorOptions={{
                    format: { type: "percent", precision: 2 },
                  }}
                >
                  <Label text="Porcentagem Mínima da Entrada" />
                </SimpleItem>
                <SimpleItem
                  colSpan={1}
                  dataField={"percJurosParcela"}
                  editorType={"dxNumberBox"}
                  cssClass="box-n2"
                  editorOptions={{
                    format: "#%",
                  }}
                >
                  <Label text="Porcentagem de Juros por Parcela" />
                </SimpleItem>
                <SimpleItem
                  colSpan={1}
                  dataField={"entradaSobreDebitoSemDescontos"}
                  editorType="dxCheckBox"
                >
                  <Label text="Entrada Sobre Débito Sem Descontos" />
                </SimpleItem>
              </GroupItem>
            </Form>
            <br />
          </div>
          <br />
          <h3>Dívidas Selecionadas</h3>
          <DataGrid
            dataSource={this.state.diats}
            showBorders={true}
            rowAlternationEnabled={true}
            remoteOperations={true}
            columnAutoWidth={true}
            columnHidingEnabled={true}
            wordWrapEnabled={window.innerWidth < 800}
          >
            <Column
              dataField={"id"}
              allowEditing={false}
              alignment={"center"}
              visible={false}
            />
            <Column
              dataField={"dividaSequencial"}
              caption={"#"}
              allowEditing={false}
              width={120}
              alignment={"center"}
            />
            <Column
              dataField={"ano"}
              caption={"Ano"}
              alignment={"center"}
              width={100}
            />
            <Column
              dataField={"origem"}
              caption={"Origem"}
              visibleIndex={3}
              width={100}
            />
            <Column
              dataField={"tributario"}
              caption={"Tributária"}
              width={100}
            />
            <Column
              dataField={"vencimento"}
              dataType="date"
              caption={"Vencimento"}
              width={100}
            />
            <Column
              dataField={"valorOriginal"}
              caption={"Vr. Original"}
              format={{ type: "fixedPoint", precision: 2 }}
              width={120}
            />
            <Column
              dataField={"multa"}
              caption={"Multa"}
              format={{ type: "fixedPoint", precision: 2 }}
              width={120}
            />
            <Column
              dataField={"descontoMulta"}
              caption={"Desc. Multa"}
              format={{ type: "fixedPoint", precision: 2 }}
              width={120}
            />
            <Column
              dataField={"juros"}
              caption={"Juros"}
              format={{ type: "fixedPoint", precision: 2 }}
              width={120}
            />
            <Column
              dataField={"descontoJuros"}
              caption={"Desc. Juros"}
              format={{ type: "fixedPoint", precision: 2 }}
              width={120}
            />
            <Column
              dataField={"correcao"}
              caption={"Correção"}
              format={{ type: "fixedPoint", precision: 2 }}
              width={120}
            />
            <Column
              dataField={"descontoCorrecao"}
              caption={"Desc. Correção"}
              format={{ type: "fixedPoint", precision: 2 }}
              width={120}
            />
            <Column
              dataField={"total"}
              caption={"Total"}
              format={{ type: "fixedPoint", precision: 2 }}
              width={120}
            />
            <Column dataField={"imovelId"} caption={"Imóvel"} />
            <Column dataField={"endereco"} caption={"Endereço"} />
            <Column dataField={"processo"} caption={"Processo"} />
            <Column dataField={"acordao"} caption={"Acordão"} />
            <Column dataField={"receita"} caption={"Receita"} />
            <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
            <Pager
              showPageSizeSelector={true}
              allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
            />
          </DataGrid>
          <br />
          <Form formData={this.state} colCount={6} labelLocation={"top"}>
            <SimpleItem
              colSpan={1}
              dataField={"qtdeCreditos"}
              cssClass="box-n2 readOnlyBox"
              editorOptions={{ readOnly: true }}
            >
              <Label text="Qtde" />
            </SimpleItem>
            <SimpleItem
              colSpan={1}
              dataField={"totalPrincipal"}
              editorType={"dxNumberBox"}
              cssClass="box-n2 readOnlyBox"
              editorOptions={{
                readOnly: true,
                format: { type: "fixedPoint", precision: 2 },
              }}
            >
              <Label text="Vr. Original (R$)" />
            </SimpleItem>
            <SimpleItem
              colSpan={1}
              dataField={"totalMulta"}
              editorType={"dxNumberBox"}
              cssClass="box-n2 readOnlyBox"
              editorOptions={{
                readOnly: true,
                format: { type: "fixedPoint", precision: 2 },
              }}
            >
              <Label text="Multa (R$)" />
            </SimpleItem>

            <SimpleItem
              colSpan={1}
              dataField={"totalJuros"}
              editorType={"dxNumberBox"}
              cssClass="box-n2 readOnlyBox"
              editorOptions={{
                readOnly: true,
                format: { type: "fixedPoint", precision: 2 },
              }}
            >
              <Label text="Juros (R$)" />
            </SimpleItem>
            <SimpleItem
              colSpan={1}
              dataField={"totalCorrecao"}
              editorType={"dxNumberBox"}
              cssClass="box-n2 readOnlyBox"
              editorOptions={{
                readOnly: true,
                format: { type: "fixedPoint", precision: 2 },
              }}
            >
              <Label text="Correção (R$)" />
            </SimpleItem>
            <SimpleItem
              colSpan={1}
              dataField={"totalDebitos"}
              editorType={"dxNumberBox"}
              cssClass="box-n2 readOnlyBox"
              editorOptions={{
                readOnly: true,
                format: { type: "fixedPoint", precision: 2 },
              }}
            >
              <Label text="Total (R$)" />
            </SimpleItem>
          </Form>
          <br />
          <br />
          <div
            style={{
              display: this.state.refisId != null ? "none" : "flex",
              marginTop: "25px",
              justifyContent: "center",
              alignContent: "center",
              justifyItems: "center",
              alignItems: "center",
            }}
          >
            <p style={{ color: "red" }}>
              Você deve selecionar uma lei antes de prosseguir!
            </p>
          </div>
          <div
            style={{
              display: "flex",
              marginTop: "25px",
              justifyContent: "center",
              alignContent: "center",
              justifyItems: "center",
              alignItems: "center",
            }}
          >
            <div style={{ marginRight: "10px" }}>
              <Button
                width={120}
                text="Voltar"
                type="normal"
                onClick={() => this.setState({ etapa: this.state.etapa - 1 })}
              />
            </div>
            <div>
              <Button
                text="Cancelar"
                type="danger"
                onClick={this.cancel}
                width={120}
              />
            </div>
            <div style={{ marginLeft: "10px" }}>
              <Button
                width={120}
                text="Prosseguir"
                type="success"
                disabled={
                  this.state.refisId === undefined ||
                  this.state.refisId === null
                }
                onClick={() => this.passarTerceiraEtapa()}
              />
            </div>
          </div>
        </div>
        <div
          className={"content-block dx-card responsive-paddings"}
          style={{ display: this.state.etapa === 3 ? "" : "none" }}
        >
          <div style={{ display: "inline-block", marginLeft: "10px" }}>
            <Button
              text="Impressão Resumida"
              icon="print"
              onClick={() => this.printReport(false)}
            />
          </div>
          <div style={{ display: "inline-block", marginLeft: "10px" }}>
            <Button
              text="Impressão Detalhada"
              icon="print"
              onClick={() => this.printReport(true)}
            />
          </div>
          <div style={{ display: "inline-block", marginLeft: "10px" }}>
            <CheckBox
              text="Exibir detalhes"
              onValueChanged={(e) => this.setState({ finalDetalhado: e.value })}
            />
          </div>

          <h3>Simulações de Parcelamento</h3>
          <DataGrid
            dataSource={this.state.simulacoes}
            showBorders={true}
            rowAlternationEnabled={true}
            remoteOperations={true}
            columnAutoWidth={true}
            columnHidingEnabled={true}
            wordWrapEnabled={window.innerWidth < 800}
          >
            <Column
              type="buttons"
              fixed={true}
              fixedPosition={"left"}
              caption=""
              width={90}
              buttons={[
                {
                  icon: "exportselected",
                  text: "Gerar Acordo",
                  onClick: (e) => this.finalizarAcordo(e)
                },
                {
                  icon: "increaseindent",
                  text: "Detalhes",
                  onClick: (e) => {
                    this.setState({
                      parcelas: e.row.data.parcelas,
                      verParcela: true,
                    });
                  },
                },
              ]}
            />
            <Column
              dataField={"qtdeParcelas"}
              caption={"Parcelas"}
              allowEditing={false}
              width={90}
              alignment={"center"}
            />
            <Column
              dataField={"principal"}
              caption={"Principal (R$)"}
              alignment={"right"}
              format={{ type: "fixedPoint", precision: 2 }}
            />
            <Column
              dataField={"juros"}
              caption={"Juros (R$)"}
              alignment={"right"}
              format={{ type: "fixedPoint", precision: 2 }}
            />
            <Column
              dataField={"multa"}
              caption={"Multa (R$)"}
              alignment={"right"}
              format={{ type: "fixedPoint", precision: 2 }}
            />
            <Column
              dataField={"correcao"}
              caption={"Correção (R$)"}
              alignment={"right"}
              format={{ type: "fixedPoint", precision: 2 }}
            />
            <Column
              dataField={"totalDebitos"}
              caption={"Total Débitos (R$)"}
              alignment={"right"}
              format={{ type: "fixedPoint", precision: 2 }}
            />
            <Column
              dataField={"percDescontoPrincipal"}
              caption={"% Desc. Principal"}
              format={{ type: "fixedPoint", precision: 2 }}
              visible={this.state.finalDetalhado}
            />
            <Column
              dataField={"descontoPrincipal"}
              caption={"Desc. Principal (R$)"}
              alignment={"right"}
              format={{ type: "fixedPoint", precision: 2 }}
              visible={this.state.finalDetalhado}
            />
            <Column
              dataField={"percDescontoJuros"}
              caption={"% Desc. Juros"}
              format={{ type: "fixedPoint", precision: 2 }}
              visible={this.state.finalDetalhado}
            />
            <Column
              dataField={"descontoJuros"}
              caption={"Desc. Juros (R$)"}
              alignment={"right"}
              format={{ type: "fixedPoint", precision: 2 }}
              visible={this.state.finalDetalhado}
            />
            <Column
              dataField={"percDescontoMulta"}
              caption={"% Desc. Multa"}
              format={{ type: "fixedPoint", precision: 2 }}
              visible={this.state.finalDetalhado}
            />
            <Column
              dataField={"descontoMulta"}
              caption={"Desc. Multa (R$)"}
              alignment={"right"}
              format={{ type: "fixedPoint", precision: 2 }}
              visible={this.state.finalDetalhado}
            />
            <Column
              dataField={"percDescontoCorrecao"}
              caption={"% Desc. Correção"}
              format={{ type: "fixedPoint", precision: 2 }}
              visible={this.state.finalDetalhado}
            />
            <Column
              dataField={"descontoCorrecao"}
              caption={"Desc. Correção (R$)"}
              alignment={"right"}
              format={{ type: "fixedPoint", precision: 2 }}
              visible={this.state.finalDetalhado}
            />
            <Column
              dataField={"totalDescontos"}
              caption={"Descontos (R$)"}
              alignment={"right"}
              format={{ type: "fixedPoint", precision: 2 }}
            />
            <Column
              dataField={"amortizacao"}
              caption={"Amortização (R$)"}
              alignment={"right"}
              format={{ type: "fixedPoint", precision: 2 }}
            />

            <Column
              dataField={"valorParcelamento"}
              caption={"Vr. Parcelamento (R$)"}
              alignment={"right"}
              format={{ type: "fixedPoint", precision: 2 }}
            />

            <Column
              dataField={"valorPrimeiraParcela"}
              caption={"1ª Parcela (R$)"}
              alignment={"right"}
              format={{ type: "fixedPoint", precision: 2 }}
            />

            <Column
              dataField={"valorUltimaParcela"}
              caption={"Últ. Parcela (R$)"}
              alignment={"right"}
              format={{ type: "fixedPoint", precision: 2 }}
            />

            <Paging pageSize={0} />
          </DataGrid>
          <br />
          <br />
          <div style={{ display: this.state.verParcela ? "" : "none" }}>
            <Form>
              <GroupItem caption={"PARCELAS"}>
                <DataGrid
                  dataSource={this.state.parcelas}
                  showBorders={true}
                  rowAlternationEnabled={true}
                  remoteOperations={true}
                  columnAutoWidth={true}
                  columnHidingEnabled={true}
                  wordWrapEnabled={window.innerWidth < 800}
                >
                  <Column
                    alignment={"center"}
                    dataField={"parcela"}
                    caption={"Parcela"}
                    width={80}
                  />
                  <Column
                    alignment={"center"}
                    dataField={"vencimento"}
                    caption={"Vencimento"}
                    dataType="date"
                    width={120}
                  />
                  <Column
                    alignment={"right"}
                    dataField={"principal"}
                    format={{ type: "fixedPoint", precision: 2 }}
                    caption={"Vr. Principal"}
                  />
                  <Column
                    alignment={"right"}
                    dataField={"juros"}
                    format={{ type: "fixedPoint", precision: 2 }}
                    caption={"Vr. Juros"}
                  />
                  <Column
                    alignment={"right"}
                    dataField={"totalParcela"}
                    format={{ type: "fixedPoint", precision: 2 }}
                    caption={"Total da Parcela"}
                  />
                  <Column
                    alignment={"right"}
                    dataField={"jurosAcrecidoPelaParcela"}
                    format={{ type: "fixedPoint", precision: 2 }}
                    caption={"Juros por Parcela"}
                  />

                  <Column dataField={"obs"} caption={"Observação"} />
                </DataGrid>
              </GroupItem>
            </Form>
          </div>
          <div
            style={{
              display: "flex",
              marginTop: "25px",
              justifyContent: "center",
              alignContent: "center",
              justifyItems: "center",
              alignItems: "center",
            }}
          >
            <div style={{ marginRight: "10px" }}>
              <Button
                width={120}
                text="Voltar"
                type="normal"
                onClick={() => this.setState({ etapa: this.state.etapa - 1 })}
              />
            </div>
            <Button
              text="Cancelar"
              type="danger"
              onClick={this.cancel}
              width={120}
            />
          </div>

          {/* <form>
            <Form formData={this.state} colCount={6} labelLocation={"top"}>
              <GroupItem colSpan={4}>
                <GroupItem
                  caption="PRINCIPAL E ENCARGOS"
                  colSpan={4}
                  colCount={4}
                >
                  <SimpleItem
                    colSpan={1}
                    dataField={"totalPrincipal"}
                    editorType={"dxNumberBox"}
                    cssClass="box-n2"
                    editorOptions={{
                      readOnly: true,
                      format: { type: "fixedPoint", precision: 2 },
                    }}
                  >
                    <Label text="Principal" />
                  </SimpleItem>
                  <SimpleItem
                    colSpan={1}
                    dataField={"totalMulta"}
                    editorType={"dxNumberBox"}
                    cssClass="box-n2"
                    editorOptions={{
                      readOnly: true,
                      format: { type: "fixedPoint", precision: 2 },
                    }}
                  >
                    <Label text="Multa" />
                  </SimpleItem>
                  <SimpleItem
                    colSpan={1}
                    dataField={"totalJuros"}
                    editorType={"dxNumberBox"}
                    cssClass="box-n2"
                    editorOptions={{
                      readOnly: true,
                      format: { type: "fixedPoint", precision: 2 },
                    }}
                  >
                    <Label text="Juros" />
                  </SimpleItem>
                  <SimpleItem
                    colSpan={1}
                    dataField={"totalCorrecao"}
                    editorType={"dxNumberBox"}
                    cssClass="box-n2"
                    editorOptions={{
                      readOnly: true,
                      format: { type: "fixedPoint", precision: 2 },
                    }}
                  >
                    <Label text="Correção" />
                  </SimpleItem>
                  <EmptyItem colSpan={3} />
                  <SimpleItem
                    colSpan={1}
                    dataField={"valorTotal"}
                    editorType={"dxNumberBox"}
                    cssClass="box-n2"
                    editorOptions={{
                      readOnly: true,
                      format: { type: "fixedPoint", precision: 2 },
                    }}
                  >
                    <Label text="Total da Dívida" />
                  </SimpleItem>
                </GroupItem>
                <GroupItem caption="DESCONTOS" colSpan={4} colCount={4}>
                  <SimpleItem
                    colSpan={1}
                    dataField={"percPrincipal"}
                    editorOptions={{
                      onValueChanged: (e) => {
                        this.atualizarDadosSegundaEtapa(
                          "PRINCIPAL_PERC",
                          e.value,
                          null
                        );
                      },
                    }}
                  >
                    <Label text="Principal(%)" />
                  </SimpleItem>
                  <SimpleItem
                    colSpan={1}
                    dataField={"percMulta"}
                    editorOptions={{
                      onValueChanged: (e) => {
                        this.atualizarDadosSegundaEtapa(
                          "MULTA_PERC",
                          e.value,
                          null
                        );
                      },
                    }}
                  >
                    <Label text="Multa(%)" />
                  </SimpleItem>
                  <SimpleItem
                    colSpan={1}
                    dataField={"percJuros"}
                    editorOptions={{
                      onValueChanged: (e) => {
                        this.atualizarDadosSegundaEtapa(
                          "JUROS_PERC",
                          e.value,
                          null
                        );
                      },
                    }}
                  >
                    <Label text="Juros(%)" />
                  </SimpleItem>
                  <SimpleItem
                    colSpan={1}
                    dataField={"percCorrecao"}
                    editorOptions={{
                      onValueChanged: (e) => {
                        this.atualizarDadosSegundaEtapa(
                          "CORRECAO_PERC",
                          e.value,
                          null
                        );
                      },
                    }}
                  >
                    <Label text="Correção(%)" />
                  </SimpleItem>
                  <SimpleItem
                    colSpan={1}
                    dataField={"valorPrincipal"}
                    editorType={"dxNumberBox"}
                    cssClass="box-n2"
                    editorOptions={{
                      format: uiInfo.formatoNumerico.n2,
                      onValueChanged: (e) => {
                        this.atualizarDadosSegundaEtapa(
                          "PRINCIPAL_VAL",
                          e.value,
                          null
                        );
                      },
                    }}
                  >
                    <Label text="Principal(R$)" />
                  </SimpleItem>
                  <SimpleItem
                    colSpan={1}
                    dataField={"valorMulta"}
                    editorType={"dxNumberBox"}
                    cssClass="box-n2"
                    editorOptions={{
                      format: uiInfo.formatoNumerico.n2,
                      onValueChanged: (e) => {
                        this.atualizarDadosSegundaEtapa(
                          "MULTA_VAL",
                          e.value,
                          null
                        );
                      },
                    }}
                  >
                    <Label text="Multa(R$)" />
                  </SimpleItem>
                  <SimpleItem
                    colSpan={1}
                    dataField={"valorJuros"}
                    editorType={"dxNumberBox"}
                    cssClass="box-n2"
                    editorOptions={{
                      format: uiInfo.formatoNumerico.n2,
                      onValueChanged: (e) => {
                        this.atualizarDadosSegundaEtapa(
                          "JUROS_VAL",
                          e.value,
                          null
                        );
                      },
                    }}
                  >
                    <Label text="Juros(R$)" />
                  </SimpleItem>
                  <SimpleItem
                    colSpan={1}
                    dataField={"valorCorrecao"}
                    editorType={"dxNumberBox"}
                    cssClass="box-n2"
                    editorOptions={{
                      format: uiInfo.formatoNumerico.n2,
                      onValueChanged: (e) => {
                        this.atualizarDadosSegundaEtapa(
                          "CORRECAO_VAL",
                          e.value,
                          null
                        );
                      },
                    }}
                  >
                    <Label text="Correção(R$)" />
                  </SimpleItem>
                  <EmptyItem colSpan={3} />
                  <SimpleItem
                    colSpan={1}
                    dataField={"totalNegociacao"}
                    editorType={"dxNumberBox"}
                    cssClass="box-n2"
                    editorOptions={{
                      readOnly: true,
                      format: { type: "fixedPoint", precision: 2 },
                    }}
                  >
                    <Label text="Total da Negociação" />
                  </SimpleItem>
                </GroupItem>
                <GroupItem caption="OUTRAS OPÇÕES" colSpan={4} colCount={5}>
                  <SimpleItem
                    colSpan={1}
                    editorType={"dxCheckBox"}
                    dataField={"exibirMsgRefis"}
                    editorOptions={{ readOnly: true }}
                  >
                    <Label text="Usando REFIS" />
                  </SimpleItem>
                  <SimpleItem
                    colSpan={1}
                    editorType={"dxDateBox"}
                    dataField={"dataParcela1"}
                    editorOptions={{ readOnly: true, width: "100%" }}
                  >
                    <Label text="Venc. 1ª Parcela" />
                  </SimpleItem>
                  <SimpleItem
                    colSpan={1}
                    dataField={"qtdeParcelas"}
                    editorOptions={{
                      onValueChanged: (e) => {
                        this.atualizarDadosSegundaEtapa(
                          "QTDE_PARCELAS",
                          e.value,
                          null
                        );
                      },
                    }}
                  >
                    <Label text="Qtde. Parcelas" />
                  </SimpleItem>
                  <SimpleItem
                    colSpan={1}
                    editorType={"dxCheckBox"}
                    dataField={"primeiraParcela"}
                    editorOptions={{
                      onValueChanged: (e) =>
                        this.setState({
                          primeiraParcela: e.value,
                          valorParcela1: null,
                        }),
                    }}
                  >
                    <Label text="1ª Parcela" />
                  </SimpleItem>
                  <SimpleItem
                    colSpan={1}
                    dataField={"valorParcela1"}
                    editorType={"dxNumberBox"}
                    cssClass="box-n2"
                    editorOptions={{
                      format: uiInfo.formatoNumerico.n2,
                      readOnly: !this.state.primeiraParcela,
                      onValueChanged: (e) => {
                        this.atualizarDadosSegundaEtapa(
                          "PARCELA1_VAL",
                          e.value,
                          null
                        );
                      },
                    }}
                  >
                    <Label text={"Vr. 1ª Parcela"} />
                  </SimpleItem>
                </GroupItem>
                <GroupItem caption="AMORTIZAÇÃO" colSpan={4} colCount={5}>
                  <SimpleItem
                    colSpan={1}
                    dataField={"valorAmortizacao"}
                    editorType={"dxNumberBox"}
                    cssClass="box-n2"
                    editorOptions={{
                      format: uiInfo.formatoNumerico.n2,
                      onValueChanged: (e) => {
                        this.atualizarDadosSegundaEtapa(
                          "AMORTIZACAO_VAL",
                          e.value,
                          null
                        );
                      },
                    }}
                  >
                    <Label text="Amortização(R$)" />
                  </SimpleItem>
                  <EmptyItem colSpan={4}></EmptyItem>
                  <SimpleItem
                    colSpan={5}
                    dataField={"motivoAmortizacao"}
                    editorType={"dxTextArea"}
                    editorOptions={{ height: "90px" }}
                  >
                    <Label text="Motivo da Amortização" />
                  </SimpleItem>
                </GroupItem>
              </GroupItem>
              <GroupItem colSpan={2}>
                <GroupItem caption={"PARCELAS"}>
                  <DataGrid
                    ref={(grid) => (this._gridParcelasInstance = grid)}
                    dataSource={this.state.parcelas}
                    showBorders={true}
                    rowAlternationEnabled={true}
                    remoteOperations={true}
                    columnAutoWidth={true}
                    columnHidingEnabled={true}
                    wordWrapEnabled={window.innerWidth < 800}
                    headerFilter={{ visible: false }}
                    filterRow={{ visible: false }}
                  >
                    <FilterRow visible={false} />
                    <Column
                      alignment={"center"}
                      dataField={"parcela"}
                      caption={"Parcela"}
                      width={80}
                    />
                    <Column
                      alignment={"center"}
                      dataField={"vencimento"}
                      caption={"Vencimento"}
                      dataType="date"
                      width={120}
                    />
                    <Column
                      alignment={"right"}
                      dataField={"valor"}
                      format={{ type: "fixedPoint", precision: 2 }}
                      caption={"Valor"}
                    />
                    <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
                    <Pager
                      showPageSizeSelector={true}
                      allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
                    />
                  </DataGrid>
                </GroupItem>
              </GroupItem>
            </Form>
            <div
              style={{
                display: "flex",
                marginTop: "25px",
                justifyContent: "center",
                alignContent: "center",
                justifyItems: "center",
                alignItems: "center",
              }}
            >
              <div style={{ marginRight: "10px" }}>
                <Button
                  width={120}
                  text="Cancelar"
                  type="default"
                  onClick={() => this.setState({ etapa: 1 })}
                />
              </div>
              <div style={{ display: "inline-block" }}>
                <Button
                  width={120}
                  text="Finalizar Negociação"
                  type="success"
                  onClick={this.ok}
                />
              </div>
            </div>
          </form> */}
        </div>
        <Popup
          visible={this.state._uiProcessando}
          dragEnabled={false}
          closeOnOutsideClick={false}
          showCloseButton={false}
          showTitle={false}
          width={150}
          height={140}>
          <ScrollView>
            <div style={{ textAlign: "center" }}>
              <LoadIndicator width={60} height={60} />
              <br />
              Carregando
            </div>
          </ScrollView>
        </Popup>
      </React.Fragment>
    );
  }

  cancel() {
    notify("Operação cancelada", "warning");
    this.setState({ ...template });
  }
}
